module.exports = __webpack_public_path__ + "static/media/Danish Dough.399103a5.jpg";